import axios from "./HttpRequestCampaign";

     function getLandingDetail(id){
         return  axios.get('/Landingpage/Detail_Landingpage_v2?IDHeader='+id);
    }

export {getLandingDetail}